import Monitor from 'lucide-react/dist/esm/icons/monitor.mjs'; import Moon from 'lucide-react/dist/esm/icons/moon.mjs'; import Sun from 'lucide-react/dist/esm/icons/sun.mjs';
import type { KeyboardEvent } from 'react';
import { setPrefs, useDisplayPrefs, type ThemePref } from '../lib/preferences.js';

/**
 * Radio groups expose one Tab stop; arrow keys select and focus the adjacent option. Lives here — in
 * the app shell's header switch — so DisplaySettings (a chunk of its own) and the editor share it
 * without a chunk for the handler alone.
 */
export function onRadioKeyDown(event: KeyboardEvent<HTMLDivElement>) {
  if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
  const radios = [...event.currentTarget.querySelectorAll<HTMLButtonElement>('[role="radio"]')];
  const current = radios.indexOf(event.target as HTMLButtonElement);
  if (current === -1 || !radios.length) return;
  event.preventDefault();
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? radios.length - 1 : (current + (event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1) + radios.length) % radios.length;
  radios[next]!.focus();
  radios[next]!.click();
}

const modes: { value: ThemePref; label: string; icon: typeof Sun }[] = [
  { value: 'light', label: 'สว่าง', icon: Sun },
  { value: 'dark', label: 'มืด', icon: Moon },
  { value: 'system', label: 'ตามเครื่อง', icon: Monitor },
];

/** Shared preference store keeps the header, editor and settings in sync. */
export function ThemeSwitch() {
  const { theme } = useDisplayPrefs();
  return <div className="xc-theme-switch" role="radiogroup" aria-label="โหมดสี" onKeyDown={onRadioKeyDown}>
    {modes.map(({ value, label, icon: Icon }) => <button
      key={value} type="button" role="radio" aria-label={label} title={`ธีม${label}`}
      aria-checked={theme === value} tabIndex={theme === value ? 0 : -1}
      onClick={() => setPrefs({ theme: value })}
    ><Icon size={16} aria-hidden="true" /><span>{label}</span></button>)}
  </div>;
}
